import React from "react";

interface ButtonProps {
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  children: React.ReactNode;
  disabled?: boolean;
  variant?: "primary" | "secondary" | "transparent";
  className?: string;
  px?: string;
}

export const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  disabled = false,
  variant = "primary",
  className = "",
  px = "px-4",
}) => {
  const baseStyles = `${px} py-2 rounded-md font-medium transition-colors duration-200`;
  const variantStyles = {
    primary: "bg-[#3490dc] text-white hover:bg-[#2779bd] disabled:bg-[#a0aec0]",
    secondary:
      "bg-gray-200 text-gray-800 hover:bg-gray-300 disabled:bg-gray-100",
    transparent:
      "bg-transparent-200 text-gray-700 hover:bg-gray-300 disabled:bg-gray-100",
  };

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`${baseStyles} ${variantStyles[variant]} ${className} font-archivo font-semibold text-[12px] leading-[19.2px] tracking-[10%]`}
    >
      {children}
    </button>
  );
};
